import { createContext } from 'react';
import { EmailSearchResult } from '../../../models/Message';

export type AddressesContextProps = {
  addresses: EmailSearchResult[];
  addressSuggestions: EmailSearchResult[];
  isLoading: boolean;
  refetchAddressSugestions: () => void;
  getAddressByMail: (mail: string) => EmailSearchResult | undefined;
};

const defaultAddressesContext: AddressesContextProps = {
  addresses: [],
  addressSuggestions: [],
  isLoading: false,
  refetchAddressSugestions: () => {},
  getAddressByMail: () => undefined,
};

export const AddressesContext = createContext<AddressesContextProps>(
  defaultAddressesContext
);
